<template>
  <el-form-item :label="title">
    <el-cascader :size="size" :disabled="disabled" :placeholder="placeholder" v-model="value" :options="options" :props="pops_cascader" filterable clearable @change="handleChange" :style="{width: width}"></el-cascader>
  </el-form-item>
</template>
<script>
import {regionList} from '@/utils/regionList.js'
export default {
  props:{
    title:{
      type: String,
      default: ''
    },
    disabled:{
      type:Boolean,
      default:false
    },
    placeholder:{
      type: String,
      default: '城市'
    },
    defaultData: {
      type: Array
    },
    type:{
      type: String,
      default: 'add'
    },
    width:{
      type: String,
      default: 'auto'
    },
    size:{
      type: String,
      default: 'mini'
    },
    // 支持数组类型的参数
    province: {
      type: [String, Array],
      default: ''
    },
    city: {
      type: [String, Array],
      default: ''
    },
    district: {
      type: [String, Array],
      default: ''
    },
    // 显示层级
    hierarchy:{
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      value: [],
      pops_cascader:{
        expandTrigger: 'hover',
        checkStrictly: true,
        value: 'id',
        label: '__EMPTY'
      },
      options: [],
    }
  },
  created() {
    this.filterRegionList()
    if(this.type == 'edit'){
      this.value = this.defaultData
      this.$forceUpdate()
    }
  },
  // 监听过滤参数变化，重新过滤数据
  watch: {
    province: {
      handler() {
        this.filterRegionList()
      },
      immediate: false
    },
    city: {
      handler() {
        this.filterRegionList()
      },
      immediate: false
    },
    district: {
      handler() {
        this.filterRegionList()
      },
      immediate: false
    }
  },
  methods: {
    // 根据参数过滤地区列表，按照 district -> city -> province 的优先级
    filterRegionList() {
      let filteredList = JSON.parse(JSON.stringify(regionList)) // 深拷贝原始数据
      // ----以下处理只显示2级-----------------------------------
      if(this.hierarchy && this.hierarchy==2){
        var newData = [];
        // 只显示2级
        // 将数据中的区县删除
        for(var i=0;i<filteredList.length;i++){
          var row = filteredList[i];
          var childs = row.children;
          // console.log("hierarchy ++", childs);
          for(var n=0;n<childs.length;n++){
            var cchilds = childs[n];
            cchilds.children = null;
            childs[n] = cchilds;
          }
          newData.push(row);
        }
        filteredList = newData;
      }
      // ----以上处理只显示2级-----------------------------------
      
      // 检查参数是否有值的辅助函数
      const hasValue = (param) => {
        if (!param) return false
        if (Array.isArray(param) && param.length === 0) return false
        if (typeof param === 'string' && !param.trim()) return false
        return true
      }
      
      // 优先级：district > city > province
      // 1. 先检查是否有区县限制
      if (hasValue(this.district)) {
        const districtIds = this.convertToArray(this.district).map(id => parseInt(id))
        // 从最底层开始过滤，确保只显示指定的区县
        filteredList = this.filterByDistrict(filteredList, districtIds)
      }
      // 2. 如果没有区县限制，检查是否有城市限制
      else if (hasValue(this.city)) {
        const cityIds = this.convertToArray(this.city).map(id => parseInt(id))
        // 过滤城市
        filteredList = this.filterByCity(filteredList, cityIds)
      }
      // 3. 如果没有城市和区县限制，检查是否有省份限制
      else if (hasValue(this.province)) {
        const provinceIds = this.convertToArray(this.province).map(id => parseInt(id))
        // 过滤省份
        filteredList = filteredList.filter(item => provinceIds.includes(item.id))
      }
      // 4. 如果都没有限制，显示全部数据
      this.options = filteredList
    },
    
    // 根据区县ID过滤数据
    filterByDistrict(list, districtIds) {
      const result = []
      
      list.forEach(province => {
        const newProvince = { ...province, children: [] }
        
        if (province.children) {
          province.children.forEach(city => {
            const newCity = { ...city, children: [] }
            
            if (city.children) {
              // 只保留指定的区县
              const filteredDistricts = city.children.filter(district => 
                districtIds.includes(district.id)
              )
              
              if (filteredDistricts.length > 0) {
                newCity.children = filteredDistricts
                newProvince.children.push(newCity)
              }
            }
          })
        }
        
        if (newProvince.children.length > 0) {
          result.push(newProvince)
        }
      })
      
      return result
    },
    
    // 根据城市ID过滤数据
    filterByCity(list, cityIds) {
      const result = []
      
      list.forEach(province => {
        const newProvince = { ...province, children: [] }
        
        if (province.children) {
          // 只保留指定的城市
          const filteredCities = province.children.filter(city => 
            cityIds.includes(city.id)
          )
          
          if (filteredCities.length > 0) {
            newProvince.children = filteredCities
            result.push(newProvince)
          }
        }
      })
      
      return result
    },
    
    // 辅助方法：将参数转换为数组
    convertToArray(param) {
      if (Array.isArray(param)) {
        return param
      } else if (typeof param === 'string' && param.trim()) {
        // 处理逗号分隔的字符串
        return param.split(',').map(item => item.trim())
      }
      return []
    },
    
    handleChange (e) {
      this.$emit('getArea', this.value)
    },
  }
}
</script>
